export function createAlmacen() {
  return {
    Clave: '',
    Nombre: '',
    Clave2: '',
    EmpresaId: 0,
    ClaveErp: '',
    EsActivo: true
  };
}
